import React from 'react';
import { connect } from 'react-redux';
import { setRoomCountFilters } from '../../../actions/filtersActions';
import withApartments from '../../../hoc/withApartments';
import FrontpageFilter from '../frontpageFilter';

const FrontpageLocationFilter = ({
	filtersReducer,
	loading,
	dispatch,
	error
}) => {
	const { roomCount, selectedRoomCount } = filtersReducer;

	return (
		<FrontpageFilter
			loading={loading}
			error={error}
			values={roomCount}
			selectedValues={selectedRoomCount}
			setFilters={setRoomCountFilters}
			dispatch={dispatch} />
	);
};

const mapStateToProps = ({ filtersReducer }) => ({
	filtersReducer
});

export default withApartments(connect(mapStateToProps)(FrontpageLocationFilter));
